/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { Row, Col, Image, Space } from "antd";
import { Button, TextField, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MainHeader from "../../../../Shared/components/Header";
import { toast } from 'react-toastify';
import clsx from "clsx";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { ListTable } from './ListTable.js';
import usePrevious from "../../../../Shared/components/Previous";
import { emptyValidation } from "../../../../../helpers/validation";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import { NavLink } from "react-router-dom";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import { checkViewPermission, checkComponentPermission } from '../../../../../helpers/utilities';

const ModuleList = (props) => {
    const { moduleDetails, loader } = useSelector(state => state.younoteAdminSecuritySetupReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { createDetails, createError, createLoader, editDetails, editError, editLoader, getList, getData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [visible, setVisible] = useState(false);
    const [errorModule, setErrorModule] = useState(false);
    const { history } = props;
    const [addMore, setAddMore] = useState(false);
    const [moduleId, setModuleId] = useState(false);
    const [module, setModule] = useState('');

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);

    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [deleteModal, setDeleteModal] = useState(false);

    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);

    const dispatch = useDispatch();

    const [form, setForm] = useState({
        module: "",
        description: ""
    });
    const [commonError, setCommonError] = useState(false);

    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");

    const classes = customStyles();

    const handleOpen = () => {
        setVisible(true);
        emptyStateInput();
        emptyState();
    };

    const handleClose = () => {
        setVisible(false);
        emptyStateInput();
        emptyState();
    };

    const changeHandler = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
    });

    useEffect(() => {
        if (roleManagement !== '' && checkViewPermission('Module List', history, 'Younote Admin')) {
            loadTasks();
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ module: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'modules',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            },
        });
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);


    const createModule = (e) => {
        e.preventDefault();
        let emptyModule = emptyValidation('Module', form.module, 'dropDown');
        if (emptyModule.isValid) {
            delete form.percentage;
            dispatch({
                type: moduleId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: 'modules',
                title: 'Module',
                id: moduleId,
                details: form
            });
        } else {
            if (emptyModule.errors) {
                setErrorModule(emptyModule.errors);
            }
        }
    }

    const emptyStateInput = () => {
        setForm({
            module: "",
        });
        setModuleId('');
    };

    const emptyState = () => {
        setErrorModule(false);
        setCommonError(false);
    };

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            loadTasks();
            handleClose();
            toast.dismiss();
            toast(createDetails);
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            setCommonError(createError.error.message);
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            handleClose();
            toast.dismiss();
            toast(editDetails);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            setCommonError(editError.error.message);
        }
    }, [editDetails, editError]);

    const onEdit = (data) => {
        setVisible(true);
        setModuleId(data.id);
        setForm({
            module: data.module,
            description: data.description,
        });
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setModuleId(data.id);
        setModule(data.module);
    };

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const handleAddMore = (e) => {
        createModule(e);
        setAddMore(true);
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }


    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.MODULE_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'modules',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Younote Admin'} links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Module List', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Module List'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Module List', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                    <div className={classes.overlFlowResponsiveDesign}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Module List', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('Modules'); }}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Module List', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Module List', 'Action', 'Add Module') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Module</span>
                                                </NavLink>
                                            }

                                            {
                                                roleManagement !== '' && checkComponentPermission('Module List', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                onEdit={(data) => onEdit(data)}
                                onDelete={(data) => onDelete(data)}
                                loadTasks={() => loadTasks()}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={`${moduleId ? 'Edit' : 'Add'} Module`}
                    width={'360px'}
                    className={classes.closeBackGround}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createModule(e)}
                        >
                            <div className={classes.customFormFlex}>
                                {
                                    commonError && <CustomAlert error={commonError} customClass={clsx(classes.uploadError, classes.margin10t)} />
                                }
                                <TextField autoComplete='one-time-code'
                                    label='Module'
                                    variant={'standard'}
                                    error={errorModule ? true : false}
                                    helperText={errorModule}
                                    name={"module"}
                                    value={form.module}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label='Description'
                                    name={"description"}
                                    value={form.description}
                                    multiline
                                    variant="outlined"
                                    className={clsx(classes.margin30t, classes.customDescription)}
                                    rows={20}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{

                                    }}

                                    onChange={(e) => changeHandler(e)}
                                />
                            </div>
                            <div className={clsx(classes.btnParent)}>

                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                    <Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}
                                    >
                                        {
                                            moduleId ? 'Update & Close' : 'Save & Close'
                                        }
                                    </Button>
                                    {
                                        !moduleId && <Button
                                            key="add"
                                            onClick={(e) => handleAddMore(e)}
                                            color='primary'
                                            variant="contained"
                                            className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                        >
                                            Add more
                                        </Button>
                                    }

                                </Space>
                            </div>
                        </Box>
                    }
                />
                <DeleteModal onClose={(v) => handleDeleteModal(v)} id={moduleId} loadTasks={() => loadTasks()} name={module} url={'modules'} title={'Modules'} visible={deleteModal} />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'Modules'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={moduleDetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment>
    )
}

export default ModuleList